type SiteMessageSorts = 'Ok' | 'Error' | 'Waring' | 'Info';

interface ISiteMessage {
    title?: string;
    message?: string;
    sort: SiteMessageSorts;
    timeOut?: number;
}

class SiteMessage
    extends QueryElement<HTMLElement> {
    private readonly _touch: QueryTouch;

    constructor(message: ISiteMessage) {
        super(document.createElement("DIV"));
        
        this._touch = new QueryTouch(this);
        this.addClass(message.sort.toLowerCase());

        let recognizer = new QueryTouchSwipeRecognizer({
            direction: QueryTouchDirection.X,
            pointers: 1,
            threshold: 10,
            velocity: 0.2
        });
        recognizer.startEvent.on(async () => {
            this.addClass("drag");
        });
        recognizer.moveEvent.on(async (e) => {
            let style = this.style();
            if(style !== undefined)
                style.transform = `translate(${e.movedX}px, 0)`;
        });
        recognizer.stopEvent.on(async(a) => {
            if(a !== "none") {
                // Close received
                this.remove();
            } else {
                // Slow mover, do not a thing :)
                this.removeClass("drag");
                let style = this.style();
                if(style !== undefined)
                    style.transform = `translate(0, 0)`;
            }
        });
        this._touch.addRecognizer(recognizer);
        
        if(message.title !== undefined)
            QueryElement.QueryElement("h2")
                .setHtml(message.title)
                .appendTo(this);
        
        if (message.message !== undefined)
            QueryElement.QueryElement("p")
                .setHtml(message.message)
                .appendTo(this);
        
        QueryElement.QueryElement("i")
            .addClass("close")
            .setText("clear")
            .appendTo(this)
            .on("click", () => {
                this.remove();
            });

        if(message.timeOut !== 0)
            window.setTimeout(() => this.remove(), (message.timeOut || 5) * 1000);
    }
}

class SiteMessages
    extends QueryElement<HTMLElement> {
    
    constructor(elem: HTMLElement) {
        super(elem);

    }

    async add(message: SiteMessage) {
        this.append(message);
    }
}